import React from "react";
import Paper from "@material-ui/core/Paper";
import { ProgressBar } from "react-bootstrap";

const CacheServer = () => {
  return (
    <Paper elevation={3}>
      <div className="system-info">
        <h4>Cache Server</h4>
        <small>Disk Space</small>
        <ProgressBar striped animated variant="danger" now={60} label="700Mbps/1000Mbps" className="mb-3" />
        <small>Memory</small>
        <ProgressBar striped animated variant="warning" now={35} label="250Mbps/1000Mbps" />
      </div>
    </Paper>
  );
};

export default CacheServer;
